import { useFieldArray } from 'react-hook-form';
import InputComponent from './component';

// must be in scope of react hook from context
const Input = ({
  name, control, isValid, ...restProps
}) => {
  const {
    fields, append, remove, update,
  } = useFieldArray({
    control,
    name,
    shouldUnregister: false,
  });

  return (
    <InputComponent
      {...restProps}
      fields={fields}
      append={append}
      remove={remove}
      name={name}
      isValid={isValid}
      update={update}
    />
  );
};

export default Input;
